/* eslint-disable no-console */

import { createLogger, isLocalEnvironment } from '@cko/dashboard-shared';

export const getFallbackLogger = () => {
  if (isLocalEnvironment()) {
    console.warn('There is no logger provided to the LoggerProvider');
  }

  return createLogger({
    context: {
      fallbackReason: 'Fallback logger used - no logger provided',
      mfe: 'unknown',
      team: 'unknown',
    },
  });
};
